// import api from '../../api/axiosClient';

// export default function useMutate(url) {
//   return {
//     post: (payload) => api.post(url, payload).then((res) => res.data),
//     put: (payload) => api.put(url, payload).then((res) => res.data),
//     patch: (payload) => api.patch(url, payload).then((res) => res.data),
//     delete: () => api.delete(url).then((res) => res.data)
//   };
// }

import api from '../../api/axiosClient';

/**
 * NOTE: this is deliberately NOT a stateful hook, despite the `use` prefix.
 *
 * 26 call sites across 10 files invoke it *inside* a callback with a dynamic
 * URL — e.g. `useMutate(`/events/delete/${eventId}`)` inside a delete handler.
 * That breaks the Rules of Hooks, so adding useState here to expose an
 * `isMutating` flag would throw "Invalid hook call" on all of them.
 *
 * The API hooks destructure `isMutating` from this and therefore always get
 * `undefined`; components relying on it for a disabled/"Saving..." state need to
 * track that locally until those call sites are refactored.
 */
export default function useMutate(url) {
  return {
    post: (payload, config = {}) => api.post(url, payload, config).then((res) => res.data),

    put: (payload, config = {}) => api.put(url, payload, config).then((res) => res.data),

    patch: (payload, config = {}) => api.patch(url, payload, config).then((res) => res.data),

    delete: (config = {}) => api.delete(url, config).then((res) => res.data)
  };
}

// import { useState } from 'react';
// import api from '../../api/axiosClient';

// export default function useMutate(url) {
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const request = async (fn) => {
//     setIsLoading(true);
//     setError(null);
//     try {
//       const res = await fn();
//       console.log('res', res);
//       return res.data;
//     } catch (err) {
//       setError(err);
//       throw err;
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return {
//     isLoading,
//     error,

//     post: (payload) => request(() => api.post(url, payload)),
//     put: (payload) => request(() => api.put(url, payload)),
//     patch: (payload) => request(() => api.patch(url, payload)),
//     delete: () => request(() => api.delete(url))
//   };
// }

// corrected version
// export default function useMutate(baseUrl) {
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const request = async (fn) => {
//     setIsLoading(true);
//     setError(null);
//     try {
//       const res = await fn();
//       return res.data;
//     } catch (err) {
//       setError(err);
//       throw err;
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return {
//     isLoading,
//     error,

//     post: (payload) => request(() => api.post(baseUrl, payload)),
//     put: (payload) => request(() => api.put(baseUrl, payload)),
//     patch: (payload) => request(() => api.patch(baseUrl, payload)),

//     delete: (path = '') => request(() => api.delete(`${baseUrl}${path}`))
//   };
// }

// example code to refer
// const { data: orders, refresh } = useApi("/orders");
// const { post: createOrder, delete: deleteOrder } = useMutate("/orders");

// async function handleAdd() {
//   await createOrder({ name: "Order A" });
//   refresh(); // reload data from API
// }

// async function handleDelete(id) {
//   await deleteOrder(`/orders/${id}`);
//   refresh();
// }
